import React, { useEffect } from "react";
import { motion } from "framer-motion";
import Aos from "aos";
import "aos/dist/aos.css";

// import Experience from "./experience";

const Profile = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  return (
    <motion.div
      exit={{ opacity: 0, transition: "easeInOut" }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      {/* <Experience /> */}
      <section className="section cbg">
        <div className="section-title">
          <h2>Educational Background</h2>
          <div className="underline"></div>
          <ul>
            <li>
              <a href="https://www.linkedin.com" className="social-icon">
                <i className="fab fa-linkedin"></i>
              </a>
            </li>
          </ul>
        </div>
        <motion.div
          className="section-center services-center"
          exit={{ opacity: 0, x: "-100vw", transition: "easeInOut" }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <article className="service" data-aos="fade-up">
            <h4>Full Stack Web Developer Boot camp</h4>
            <div className="underline"></div>
            <h4>Pana Cloud </h4>
            <div className="underline"></div>
            <h4>2019-2020</h4>

            <p>HTML/CSS/Java Script</p>
            <p>React / Angular / Vue</p>
            <p>Firebase</p>
            <p>Aws</p>
            <p>Laravel</p>
          </article>
          <article className="service" data-aos="fade-up">
            <h4>E-learning</h4>
            <div className="underline"></div>
            <h4>Networks, Administration, Web Development</h4>
            <div className="underline"></div>
            <h4>2021</h4>

            <p>HTML/CSS/Java Script</p>
            <p>React</p>
            <p>Amazon Web Services</p>
            <p>Cisco ASA Labs</p>
            <p>CCCNP Labs</p>
          </article>
          <article className="service" data-aos="fade-up">
            <h4>Oslo and Akershus University College</h4>
            <div className="underline"></div>
            <h4>Enterprise Networking: Practices and Technologies </h4>
            <div className="underline"></div>
            <h4>2014</h4>

            <p>Advance Single Subject Master Level Course.</p>
            <p>Cloud Based Network</p>
            <p>VmWare</p>
            <p>Advance Lab Work on Virtual Box</p>
          </article>

          <article className="service" data-aos="fade-up">
            <h4>Halmstad University, Halmstad Sweden</h4>
            <div className="underline"></div>
            <h4>Diploma in Network Design And Management 30 ECTS</h4>
            <div className="underline"></div>
            <h4>2012</h4>

            <p>System Administration</p>
            <p>Routing</p>
            <p>Security</p>
            <p>Switching</p>
            <p>Linux Administration</p>
          </article>
          <article className="service" data-aos="fade-up">
            <h4>Halmstad University, Halmstad Sweden</h4>
            <div className="underline"></div>
            <h4>Certifications</h4>
            <div className="underline"></div>
            <h4>2012</h4>

            <p>CCNP Routing Exploration</p>
            <p>CCNA Security Exploration</p>
            <p>CCNA Exploration</p>
          </article>

          <article className="service" data-aos="fade-up">
            <h4>Blekinge Institute of Technology Karlskrona</h4>
            <div className="underline"></div>
            <h4>MSC EE Spcialize in Telecomunication 90 ECTS</h4>
            <div className="underline"></div>
            <h4>2010</h4>

            <p>Modern Techniques of Networking</p>
            <p>TCP/IP </p>
            <p>Digital Transmission</p>
            <p>Complex Analaysis</p>
          </article>

          <article className="service" data-aos="fade-up">
            <h4>B.Z University Multan Pakistan</h4>
            <div className="underline"></div>
            <h4>BS in Telecommunication System</h4>
            <div className="underline"></div>
            <h4>2008</h4>

            <p>Data Communication</p>
            <p>Computer Networks</p>
            <p>Telecommunication Management</p>
            <p>Wireless Communication</p>
          </article>
        </motion.div>
      </section>
    </motion.div>
  );
};

export default Profile;
